module.exports = __webpack_public_path__ + "8a5a2ec1fd21c2f90ba0bdab05d3bcc4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/telegren.ttf
// module id = 725
// module chunks = 0